// AMENITY
import {AmenityIconsEnum} from '../components/amenities/icons'
import {TranslatorScope} from '../locale/types'
import {omit, optionsToMapObject} from '../utils/logic'

export const AMENITY_TYPE_BAR = 'BAR'
export const AMENITY_TYPE_SPA = 'SPA'
export const AMENITY_TYPE_GYM = 'GYM'
export const AMENITY_TYPE_CAFE = 'CAFE'
export const AMENITY_TYPE_WIFI = 'WIFI'
export const AMENITY_TYPE_SAUNA = 'SAUNA'
export const AMENITY_TYPE_JACUZZI = 'JACUZZI'
export const AMENITY_TYPE_LOCKERS = 'LOCKERS'
export const AMENITY_TYPE_TOILETS = 'TOILETS'
export const AMENITY_TYPE_SHOWERS = 'SHOWERS'
export const AMENITY_TYPE_RESTAURANT = 'RESTAURANT'
export const AMENITY_TYPE_STEAM_ROOM = 'STEAM_ROOM'
export const AMENITY_TYPE_INDOOR_POOL = 'INDOOR_POOL'
export const AMENITY_TYPE_HAIR_DRYERS = 'HAIR_DRYERS'
export const AMENITY_TYPE_PAID_PARKING = 'PAID_PARKING'
export const AMENITY_TYPE_OUTDOOR_POOL = 'OUTDOOR_POOL'
export const AMENITY_TYPE_FREE_PARKING = 'FREE_PARKING'
export const AMENITY_TYPE_VALET_PARKING = 'VALET_PARKING'
export const AMENITY_TYPE_CHANGING_ROOM = 'CHANGING_ROOM'
export const AMENITY_TYPE_STREET_PARKING = 'STREET_PARKING'
export const AMENITY_TYPE_INDOOR_PARKING = 'INDOOR_PARKING'
export const AMENITY_TYPE_EQUIPMENT_SHOP = 'EQUIPMENT_SHOP'
export const AMENITY_TYPE_OUTDOOR_PARKING = 'OUTDOOR_PARKING'
export const AMENITY_TYPE_EQUIPMENT_RENTAL = 'EQUIPMENT_RENTAL'
// export const AMENITY_TYPE_TOWELS = 'EQUIPMENT_TOWELS'
// export const AMENITY_TYPE_EQUIPMENT = 'EQUIPMENT'

type Amenity = {
  icon: keyof typeof AmenityIconsEnum;
  value: string;
  label: TranslatorScope;
}

export const AMENITY_TYPE_OPTIONS: Amenity[] = [
  {
    icon: 'Bar', value: AMENITY_TYPE_BAR, label: 'bar'
  },
  {
    icon: 'Spa', value: AMENITY_TYPE_SPA, label: 'spa'
  },
  {
    icon: 'Gym', value: AMENITY_TYPE_GYM, label: 'gym'
  },
  {
    icon: 'Cafe', value: AMENITY_TYPE_CAFE, label: 'cafe'
  },
  {
    icon: 'Wifi', value: AMENITY_TYPE_WIFI, label: 'wifi'
  },
  {
    icon: 'Sauna', value: AMENITY_TYPE_SAUNA, label: 'sauna'
  },
  {
    icon: 'Jacuzzi', value: AMENITY_TYPE_JACUZZI, label: 'jacuzzi'
  },
  {
    icon: 'Lockers', value: AMENITY_TYPE_LOCKERS, label: 'lockers'
  },
  {
    icon: 'Toilets', value: AMENITY_TYPE_TOILETS, label: 'toilets'
  },
  {
    icon: 'Showers', value: AMENITY_TYPE_SHOWERS, label: 'showers'
  },
  {
    icon: 'SteamRoom', value: AMENITY_TYPE_STEAM_ROOM, label: 'steamRoom'
  },
  {
    icon: 'Restaurant', value: AMENITY_TYPE_RESTAURANT, label: 'restaurant'
  },
  {
    icon: 'IndoorPool', value: AMENITY_TYPE_INDOOR_POOL, label: 'indoorPool'
  },
  {
    icon: 'HairDryers', value: AMENITY_TYPE_HAIR_DRYERS, label: 'hairDryers'
  },
  {
    icon: 'PaidParking', value: AMENITY_TYPE_PAID_PARKING, label: 'paidParking'
  },
  {
    icon: 'OutdoorPool', value: AMENITY_TYPE_OUTDOOR_POOL, label: 'outdoorPool'
  },
  {
    icon: 'FreeParking', value: AMENITY_TYPE_FREE_PARKING, label: 'freeParking'
  },
  {
    icon: 'ValetParking',
    value: AMENITY_TYPE_VALET_PARKING,
    label: 'valetParking',
  },
  {
    icon: 'ChangingRoom',
    value: AMENITY_TYPE_CHANGING_ROOM,
    label: 'changingRooms',
  },
  {
    icon: 'StreetParking',
    value: AMENITY_TYPE_STREET_PARKING,
    label: 'streetParking',
  },
  {
    icon: 'IndoorParking',
    value: AMENITY_TYPE_INDOOR_PARKING,
    label: 'indoorParking',
  },
  {
    icon: 'EquipmentShop',
    value: AMENITY_TYPE_EQUIPMENT_SHOP,
    label: 'equipmentShop',
  },
  {
    icon: 'Equipment',
    value: AMENITY_TYPE_EQUIPMENT_RENTAL,
    label: 'equipmentHire',
  },
  {
    icon: 'OutdoorParking',
    value: AMENITY_TYPE_OUTDOOR_PARKING,
    label: 'outdoorParking',
  },
]

export const AMENITY_TYPE_MAP = optionsToMapObject(
  AMENITY_TYPE_OPTIONS,
  (obj) => omit(obj, ['value']),
)